import { Base, Component } from '@/vue-property-decorator'
import { useI18n } from '@/i18n'
import { useMainStore } from '@/store/index'
import { windowOpen } from '@/utils/business-utils'
import style from './style.module.scss'

/** 官方频道*/
@Component<OfficialChannel>({
  name: 'OfficialChannel'
})
export default class OfficialChannel extends Base {
  render() {
    const { t } = useI18n()
    const channelList = useMainStore()?.officialChannelList
    if (channelList.length === 0) {
      return <template></template>
    }
    return (
      <div class={[style.channelBox, 'channel-box']}>
        <div class={style.title}> {t('lobby.officialChannel.title')}</div>
        <div class={style.channelItems}>
          {channelList.map((item) => {
            return (
              <my-img
                src={item.icon}
                class={[style.channelItem, 'channel-item']}
                onClick={() => windowOpen(item.url)}
              />
            )
          })}
        </div>
      </div>
    )
  }
}
